import { render } from "./RuTubeEmbed.vue?vue&type=template&id=2b7eac79&scoped=true"
import script from "./RuTubeEmbed.vue?vue&type=script&lang=js"
export * from "./RuTubeEmbed.vue?vue&type=script&lang=js"

import "./RuTubeEmbed.vue?vue&type=style&index=0&id=2b7eac79&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7eac79"]])

export default __exports__